module.exports = __webpack_public_path__ + "static/tools-200afb7d4ea94f5cc1712ae21e6b8a1c.svg";